// auth.config.ts
import { InjectionToken } from '@angular/core';

export interface AuthConfig {
  apiBase: string;
  signInPath: string;
  signOutPath: string;
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');